/**
 * Shared utilities for Navigation components
 */

/**
 * Validates if a link object has valid internal or external link with label
 * @param {Object} link - Link object with internalLink, externalLink, and label properties
 * @returns {boolean} - True if link is valid
 */
export const isValidLink = (link) => {
  if (!link) return false;
  return (link.internalLink || link.externalLink) && link.label;
};

/**
 * Creates navigation items configuration from menu labels and flyouts
 * @param {Array} labels - Array of menu link labels
 * @param {Array} flyouts - Array of menu link flyout references
 * @param {Array} ids - Array of navigation item IDs
 * @returns {Array} - Filtered array of navigation items with id, label, and flyout
 */
export const createNavItems = (labels, flyouts, ids) => {
  return labels
    .map((label, index) => ({
      id: ids[index],
      label,
      flyout: flyouts[index],
    }))
    .filter(item => item.label);
};

/**
 * Creates utility items configuration from links
 * @param {Array} items - Array of objects with link and icon properties
 * @returns {Array} - Filtered array of utility items
 */
export const createUtilityItems = (items) => {
  return items.filter(item => item.link);
};
